module.exports = __webpack_public_path__ + "img/puzzle8.jpg";